import React from "react";

const Category = () => {
    return (
        <>
            <h1>Category</h1>
        </>
    );
}

export { Category };